<template>
	<div v-if="showBanner && userId">
		<v-alert color="#2dc7ae" :icon="false" class="connect-eoloquence-banner mb-0 py-2" tile width="100%" dark>
			<div class="connect-eoloquence-banner__layout">
				<div class="connect-eoloquence-banner__body">
					<span class="connect-eoloquence-banner__text">
						<strong>Eloquence IQ</strong> est là : entraînez-vous à l'oral avec l'IA, comme avec un coach — essayez,
						c'est le moment !
					</span>
					<LoginToEloquenceBtn :userId="userId" />
				</div>
				<v-btn icon small class="connect-eoloquence-banner__close" aria-label="Fermer" @click="closeBanner">
					<v-icon color="white">mdi-close</v-icon>
				</v-btn>
			</div>
		</v-alert>
	</div>
</template>

<script>
import LoginToEloquenceBtn from '@/components/buttons/LoginToEloquenceBtn.vue';

const BANNER_HIDDEN_UNTIL_STORAGE_KEY = 'orthographiq_connect_eoloquence_banner_hidden_until_ms';
const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

/**
 * Banner prompting users to try Eloquence IQ, with a trial form modal.
 *
 * @changed_at 30/03/2026 by AI (claude-4.6-sonnet-medium)
 */
export default {
	name: 'ConnectEoloquenceRequest',
	components: {
		LoginToEloquenceBtn,
	},
	data() {
		return {
			showBanner: false,
			showFormModal: false,
		};
	},
	computed: {
		userId() {
			if (!this.$store.state) return null;
			if (!this.$store.state.profile) return null;
			if (!this.$store.state.profile.profileInfos) return null;
			return this.$store.state.profile.profileInfos._id;
		},
	},
	mounted() {
		this.setCanShowBanner();
	},
	methods: {
		closeBanner() {
			localStorage.setItem(BANNER_HIDDEN_UNTIL_STORAGE_KEY, String(Date.now() + TWENTY_FOUR_HOURS_MS));
			this.showBanner = false;
		},
		readBannerHiddenUntilMs() {
			try {
				const raw = localStorage.getItem(BANNER_HIDDEN_UNTIL_STORAGE_KEY);
				if (raw === null || raw === '') return null;

				const until = Number(raw);
				return Number.isFinite(until) ? until : null;
			} catch {
				return null;
			}
		},
		setCanShowBanner() {
			const until = this.readBannerHiddenUntilMs();
			if (until === null) return (this.showBanner = true);
			if (Date.now() < until) return (this.showBanner = false);
			localStorage.removeItem(BANNER_HIDDEN_UNTIL_STORAGE_KEY);
			this.showBanner = true;
		},
	},
};
</script>

<style scoped>
.connect-eoloquence-banner__layout {
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
}

.connect-eoloquence-banner__body {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	text-align: center;
}

.connect-eoloquence-banner__text {
	line-height: 1.4;
	font-weight: 500;
}

.connect-eoloquence-banner__cta {
	flex-shrink: 0;
}

.connect-eoloquence-banner__close {
	flex-shrink: 0;
	align-self: flex-start;
	margin-top: 2px;
}

@media (min-width: 600px) {
	.connect-eoloquence-banner__body {
		flex-direction: row;
		justify-content: center;
		text-align: left;
	}

	.connect-eoloquence-banner__close {
		align-self: center;
		margin-top: 0;
	}
}
</style>
